const getFolderWithAncestorIds = (folderId, folders) => {
  const foldersById = new Map(folders.map((folder) => [folder.id, folder]));
  const ids = [];
  let currentId = folderId;

  while (currentId && foldersById.has(currentId) && !ids.includes(currentId)) {
    ids.push(currentId);
    currentId = foldersById.get(currentId).parentFolderId;
  }

  return ids;
};

export default getFolderWithAncestorIds;
